import { Component, OnInit, Input } from '@angular/core';
import {Router} from '@angular/router';
import { ImageItem } from '../../image-item/image-item.component';

@Component({
  selector: 'event-item',
  templateUrl: './event-item.template.html',
  styleUrls: ['./event-item.styles.scss']
})
export class EventItem {
  @Input() event$: any;

  constructor(
    private router : Router
  ){ }

}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/events/event-item/event-item.component.ts